"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const CoreContext_1 = require("../../contexts/CoreContext");
const JoinLauncherContext_1 = require("../../contexts/join-launcher/JoinLauncherContext");
const downloadTeamsImg = require("../../images/download_teams_desktop.svg");
const Environment_1 = require("../../models/Environment");
const DownloadService_1 = require("../../services/DownloadService");
const AppStoreButtonRenderer_1 = require("../common/AppStoreButtonRenderer");
const Footer_1 = require("../common/Footer");
const TeamsLogo_1 = require("../common/TeamsLogo");
const Translate_1 = require("../common/Translate");
const View_1 = require("../common/View");
require("./TflDesktopComingSoonView.scss");
class TflDesktopComingSoonView extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement(View_1.View, { className: "comingSoon" },
            React.createElement("div", { className: "header", role: "banner" },
                React.createElement(TeamsLogo_1.TeamsLogo, null)),
            React.createElement("div", { className: "body column centered", role: "main" },
                React.createElement("img", { className: "partyImage", id: "party-image", src: downloadTeamsImg, "aria-hidden": "true" }),
                React.createElement("h2", { className: "title" },
                    React.createElement(Translate_1.Translate, { i18n: "hdr_supported_platforms_header" }),
                    React.createElement("br", null),
                    React.createElement(Translate_1.Translate, { i18n: "hdr_coming_soon_header" })),
                React.createElement("div", { className: "desktopMessage" },
                    React.createElement("span", null,
                        React.createElement(Translate_1.Translate, { i18n: "txt_coming_soon_get_mobile" }))),
                React.createElement(CoreContext_1.CoreContextConsumer, null, ({ language, languageBundle, environment, featureFlags, launcherService }) => (React.createElement(JoinLauncherContext_1.JoinLauncherContextConsumer, null, ({ joinInfo, downloadState }) => {
                    const iosEnv = Object.assign({}, environment);
                    iosEnv.os = Environment_1.OperatingSystems.iOS;
                    const iosDownloadBehavior = DownloadService_1.default.getDownloadBehaviour(joinInfo, iosEnv, featureFlags, launcherService, downloadState);
                    const androidEnv = Object.assign({}, environment);
                    androidEnv.os = Environment_1.OperatingSystems.Android;
                    const androidDownloadBehavior = DownloadService_1.default.getDownloadBehaviour(joinInfo, androidEnv, featureFlags, launcherService, downloadState);
                    return React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "buttonsContainer" },
                            React.createElement(AppStoreButtonRenderer_1.AppStoreButtonRenderer, { key: "iosButton", requestedLanguage: language, languageBundle: languageBundle, joinInfo: joinInfo, downloadBehavior: iosDownloadBehavior }),
                            React.createElement(AppStoreButtonRenderer_1.AppStoreButtonRenderer, { key: "androidButton", requestedLanguage: language, languageBundle: languageBundle, joinInfo: joinInfo, downloadBehavior: androidDownloadBehavior })));
                })))),
            React.createElement("div", { className: "legalNotice" },
                React.createElement(Translate_1.Translate, { i18n: "hdr_disclaimer_apple" })),
            React.createElement("div", { className: "legalNotice" },
                React.createElement(Translate_1.Translate, { i18n: "hdr_disclaimer_android" })),
            React.createElement(Footer_1.Footer, null)));
    }
}
exports.TflDesktopComingSoonView = TflDesktopComingSoonView;
